import { fetchregulatoryCountry } from "../../../api/regulatory/regulatoryCountry.service"
import { FETCH_REGULATORY_COUNTRY } from "../actionTypes"

const requestListRequest = ()=>({type: FETCH_REGULATORY_COUNTRY.REQUEST})
const requestListFailure = (error)=>({type: FETCH_REGULATORY_COUNTRY.FAILURE, error})
const requestListSuccess = (obj)=>({type: FETCH_REGULATORY_COUNTRY.SUCCESS, obj})


export const getRegulatoryCountry = (option)=>{
    return (dispatch, getState)=>{        
        dispatch(requestListRequest())
        return fetchregulatoryCountry(option)  
        .then(response => {            
            dispatch(requestListSuccess(response))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(requestListFailure(error?.message))
            return Promise.resolve(false)
        })
    }
}